<template>
	<div class="home_page">
		<div class="hm_page" v-show="!loading">
			<div class="pc_box" v-if="!isPhone">
				<swiper class="swiper_wrap" @slideChange="pageChange" :options="swiperOption1" ref="mySwiper1">
					<swiper-slide class="wrap_item flex2">
						<template>
							<swiper class="swiper_box1" :options="swiperOption2" ref="mySwiper2" @slideChange="onSlideChange"
								v-if="swiperList.length">
								<swiper-slide class="swiper_item flex2">
									<div class="vid_box">
										<video ref="videoPlayer" preload="metadata" :autoplay="isauto" :muted="ismute" :src="videoobj.file"
											@ended="onVideoEnded"></video>
										<img v-if="ismute" class="mute_img" src="@/images/mute2.png" @click="muteChange" />
										<img v-else class="mute_img" src="@/images/mute1.png" @click="muteChange" />
									</div>
								</swiper-slide>
								<swiper-slide class="swiper_item" v-for="(item, index) in swiperList" :key="index">
									<div class="img_box flex2">
										<img :src="staticImg + item.image" />
									</div>
								</swiper-slide>
								<div class="swiper-pagination" slot="pagination"></div>
							</swiper>
						</template>
					</swiper-slide>
					<swiper-slide class="wrap_item">
						<div class="slid2_box flex2" v-if="show2">
							<img class="slid2_img1" src="@/images/slid23.png" />
							<div>
								<img class="slid2_img2" src="@/images/slid_tit.png">
							</div>
						</div>
					</swiper-slide>
					<swiper-slide class="wrap_item slid3_box flex2">
						<div class="sort_box flex3" v-if="show3">
							<div class="sort_item item_sty1 animate__animated animate__zoomIn" :class="moveAct == 1 ? 'hdzz' : ''"
								@mouseenter="moveIn(1)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg1.png" />
								<div class="zhezhao"></div>
								<div class="zz_box">
									<p class="zz_tit animate__animated" :class="moveAct == 1? 'animate__bottomUp': 'animate__bottomDown'">
										浓香
									</p>
									<p class="zz_con animate__animated" :class="moveAct == 1? 'animate__fadeInUp': 'animate__fadeOutDown'">
										取天地精华，酿中国正宗多粮浓香白酒
									</p>
								</div>
							</div>
							<div class="sort_item item_sty2 animate__animated animate__zoomIn"
								:class="moveAct == 2 ? 'hdzz' : 'bottomDown'" @mouseenter="moveIn(2)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg2.png" />
								<div class="zhezhao"></div>
								<p class="zz_tit animate__animated" :class="moveAct == 2 ? 'animate__bottomUp': 'animate__bottomDown'">
									御酒
								</p>
								<p class="zz_con animate__animated" :class="moveAct == 2? 'animate__fadeInUp': 'animate__fadeOutDown'">
									载入正史至今尚存的唐代宫廷御酒
								</p>
							</div>
							<div class="sort_item item_sty1 animate__animated animate__zoomIn" :class="moveAct == 3 ? 'hdzz' : ''"
								@mouseenter="moveIn(3)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg3.png" />
								<div class="zhezhao"></div>
								<p class="zz_tit animate__animated" :class="moveAct == 3? 'animate__bottomUp': 'animate__bottomDown'">
									匠心
								</p>
								<p class="zz_con animate__animated" :class="moveAct == 3? 'animate__fadeInUp': 'animate__fadeOutDown'">
									1500年匠心坚持 御酒品质始终如一
								</p>
							</div>
							<div class="sort_item item_sty2 animate__animated animate__zoomIn" :class="moveAct == 4 ? 'hdzz' : ''"
								@mouseenter="moveIn(4)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg4.png" />
								<div class="zhezhao"></div>
								<p class="zz_tit animate__animated" :class="moveAct == 4? 'animate__bottomUp': 'animate__bottomDown'">
									名酒
								</p>
								<p class="zz_con animate__animated" :class="moveAct == 4? 'animate__fadeInUp': 'animate__fadeOutDown'">
									蝉联“全国名酒”称号，获多项国内外大奖
								</p>
							</div>
							<div class="sort_item item_sty1 animate__animated animate__zoomIn" :class="moveAct == 5 ? 'hdzz' : ''"
								@mouseenter="moveIn(5)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg5.png" />
								<div class="zhezhao"></div>
								<p class="zz_tit animate__animated" :class="moveAct == 5? 'animate__bottomUp': 'animate__bottomDown'">
									万吨
								</p>
								<p class="zz_con animate__animated" :class="moveAct == 5? 'animate__fadeInUp': 'animate__fadeOutDown'">
									拥有多个万吨级原酒陶坛贮存库
								</p>
							</div>
							<div class="sort_item item_sty1 animate__animated animate__zoomIn" :class="moveAct == 6 ? 'hdzz' : ''"
								@mouseenter="moveIn(6)" @mouseleave="moveOut">
								<img class="zhutu" src="@/images/syimg6.png" />
								<div class="zhezhao"></div>
								<p class="zz_tit animate__animated" :class="moveAct == 6? 'animate__bottomUp': 'animate__bottomDown'">
									专利
								</p>
								<p class="zz_con animate__animated" :class="moveAct == 6? 'animate__fadeInUp': 'animate__fadeOutDown'">
									“挥发系数鉴别年份酒的方法”获国家发明专利
								</p>
							</div>
						</div>
						<div class="rd_box">
							<record></record>
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div class="phone_home" v-if="isPhone">
				<Header2 :searchShow="true" pageTitle="剑南春官方网站"></Header2>
				<div class="swiper3">
					<swiper class="swiper_box3" :options="swiperOption3" ref="mySwiper3">
						<swiper-slide class="swiper_item3 flex2" v-for="(item, index) in swiperList2" :key="index">
							<div class="img_box3">
								<img src="@/images/phone/swp1.png" />
							</div>
						</swiper-slide>
					</swiper>
				</div>
				<div class="wl_img">
					<img src="@/images/phone/img1.png" />
				</div>
				<div class="key_list">
					<div class="key_item">
						<p class="key_tit">浓香</p>
						<p class="key_p1">取天地精华，酿中国正宗多粮浓香白酒</p>
						<div class="key_d1">
							<img src="@/images/phone/img2.png" />
						</div>
					</div>
					<div class="key_item">
						<p class="key_tit">御酒</p>
						<p class="key_p1">载入正史至今尚存的唐代宫廷御酒</p>
						<div class="key_d1">
							<img src="@/images/phone/img3.png" />
						</div>
					</div>
					<div class="key_item">
						<p class="key_tit">匠心</p>
						<p class="key_p1">1500年匠心坚持 御酒品质始终如一</p>
						<div class="key_d1">
							<img src="@/images/phone/img4.png" />
						</div>
					</div>
					<div class="key_item">
						<p class="key_tit">名酒</p>
						<p class="key_p1">蝉联“全国名酒”称号，获多项国内外大奖</p>
						<div class="key_d1">
							<img src="@/images/phone/img5.png" />
						</div>
					</div>
					<div class="key_item">
						<p class="key_tit">万吨</p>
						<p class="key_p1">拥有多个万吨级原酒陶坛贮存库</p>
						<div class="key_d1">
							<img src="@/images/phone/img6.png" />
						</div>
					</div>
					<div class="key_item">
						<p class="key_tit">专利</p>
						<p class="key_p1">“挥发系数鉴别年份酒的方法”获国家发明专利</p>
						<div class="key_d1">
							<img src="@/images/phone/img7.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex2 load_page" v-show="loading">
			<img src="@/images/load.gif" />
		</div>
		<div class="kp_box" v-show="kaiPing==2&&!isPhone&&!loading">
			<img class="kp_left animate__animated animate__slideOutLeft" src="@/images/open1.png" />
			<img class="kp_right animate__animated animate__slideOutRight" src="@/images/open2.png" />
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			currentIndex: 0,
			swiperOption1: {
				direction: "vertical",
				mousewheel: true,
			},
			swiperOption2: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				initialSlide: 0, // 初始显示第一个（视频）
				loop: true, // 禁用循环，避免索引错乱
				mousewheel: true,
				speed: 1000, //切换速度
			},
			swiperOption3: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				mousewheel: true,
				loop: true, //开启循环
				speed: 1000, //切换速度
				autoplay: true,
			},
			ismute: false,
			isauto: false,
			videoId: "",
			show2: false,
			show3: false,
			moveAct: "",
			swiperList: [],
			videoobj: {},
			swiperList2: [],
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
			loading: true,
		};
	},
	computed: {
		...mapState(["kaiPing"]),
		swiper22() {
			return this.$refs.mySwiper2.$swiper;
		}
	},
	mounted() {
		// console.log('页面加载完毕')
	},
	created() {
		this.loading = this.$store.state.loadPage;
		this.indexBanner(1); //电脑
		this.indexBanner(2); //手机
	},
	methods: {
		// 轮播图
		async indexBanner(type) {
			const res = await this.$api.indexBanner({
				leixing: type,
			});
			if (res.code == 1) {
				setTimeout(() => {
					this.$store.state.loadPage = false;
                    this.loading = false;
					//1不显示 2显示 3已经显示过了
					if (this.$store.state.kaiPing == 1) {
						this.$store.state.kaiPing = 2;//默认开屏页不显示，数据加载好后开屏动画执行
					}
				}, 2000);
				setTimeout(() => {
					this.$store.state.kaiPing = 3;//2.5秒后开屏动画消失
				}, 5000);
				if (type == 1) {
					var data3 = res.data;
					for (let i = 0; i < data3.length; i++) {
						if (data3[i].file == '') {
							this.swiperList.push(data3[i]);
						} else {
							this.videoobj = data3[i];
							this.videoobj.file = this.$staticImg + this.videoobj.file;
						}
					}
				}
				if (type == 2) {
					this.swiperList2 = res.data;
				}
			} else {
				setTimeout(() => {
					this.$store.state.loadPage = false;
                    this.loading = false;
					this.isauto = true;
				}, 4000);
			}
		},
		pageChange() {
			const swiper1 = this.$refs.mySwiper1.$swiper;
			const current1 = swiper1.realIndex;
			if (current1 == 2) {
				this.show3 = true;
			}
            if (current1 == 1) {
				this.show2 = true;
			}
		},
		// 轮播图切换
		onSlideChange() {
			const currentIndex = this.swiper22.realIndex;
			if (currentIndex == 0) {
				this.isauto = true;
				this.swiper22.autoplay.stop();
				this.$nextTick(() => {
					this.$refs.videoPlayer.play();
					this.$forceUpdate();
				});
			} else {
				this.swiper22.autoplay.start();
				this.$refs.videoPlayer.pause();
			}
		},
		onVideoEnded() {
			this.swiper22.slideNext();
			this.swiper22.autoplay.start();
		},
		muteChange() {
			this.ismute = !this.ismute;
			this.isauto = !this.isauto;
		},
		moveOut() {
			this.moveAct = "";
		},
		moveIn(a) {
			this.moveAct = a;
		},
	}
};
</script>
<style lang="scss">
.load_page {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 999999999999999;
	background-color: #fff;
	width: 100vw;
	height: 100vh;
	img {
		width: 100px;
		height: 75px;
	}
}
.home_page {
	@font-face {
		font-family: "SourceHanSans";
		src: url("../../font/SourceHanSansCN-Regular.otf");
	}
	font-family: "SourceHanSans";
	// 隐藏遮罩
	.hdzz {
		.zhezhao {
			background-color: rgba(0, 0, 0, 0.2) !important;
		}
	}
	.hm_page {
		.pc_box {
			margin-top: 74px;
			.swiper_wrap {
				width: 100%;
				height: calc(100vh - 150px);
				.wrap_item {
					width: 100%;
					height: calc(100vh - 150px);
					.swiper_box1 {
						.swiper_item {
							width: 100%;
							height: calc(100vh - 150px);
							.vid_box {
								background-color: #000;
								position: relative;
								width: 100%;
								height: calc(100vh - 150px);
								video {
									width: 100vw;
									z-index: 9;
									height: calc(100vh - 150px);
									background-color: #000;
									z-index: 1;
								}
								.mute_img {
									position: absolute;
									right: 5px;
									top: 5px;
									z-index: 10;
									cursor: pointer;
								}
							}
							.img_box {
								overflow: hidden;
								width: 100%;
								height: calc(100vh - 150px);
								img {
									width: auto;
									height: calc(100vh - 150px);
								}
							}
						}
						.swiper-pagination {
							display: flex;
							align-items: center;
							justify-content: center;
							.swiper-pagination-bullet-active {
								background: #d43235 !important;
								border: 3px solid #d43235 !important;
							}
							.swiper-pagination-bullet {
								width: 12px;
								height: 12px;
								border: 3px solid #fff;
								background: transparent;
								opacity: 1;
								margin: 0 8px 5px 8px;
							}
						}
					}
					.slid2_box {
						width: 100%;
						height: 100%;
						align-items: flex-start;
						justify-content: flex-start;
						position: relative;
						.slid2_img1 {
							width: 1920px;
							height: 1080px;
							position: relative;
							top: -80px;
						}
						div {
							position: absolute;
							left: 0;
							right: 0;
							top: 0;
							bottom: 0;
							background-color: rgba(11, 49, 90, 0.3);
							z-index: 1;
							padding-top: calc(50vh - 120px);
							padding-left: 260px;
							text-align: left;
							.slid2_img2 {
								width: 430px;
							}
						}
					}
				}
				.slid3_box {
					background-image: url("../../images/slid3.png");
					background-size: 100% 100%;
					background-repeat: no-repeat;
					position: relative;
					.sort_box {
						max-width: 1410px;
						flex-wrap: wrap;
						.sort_item {
							position: relative;
							overflow: hidden;
							padding: 0 4px;
							box-sizing: border-box;
							margin-bottom: 4px;
							cursor: pointer;
							&:nth-child(1) {
								animation-delay: 0.1s;
							}
							&:nth-child(2) {
								animation-delay: 0.3s;
							}
							&:nth-child(3) {
								animation-delay: 0.5s;
							}
							&:nth-child(4) {
								animation-delay: 0.7s;
							}
							&:nth-child(5) {
								animation-delay: 0.9s;
							}
							&:nth-child(6) {
								animation-delay: 1.1s;
							}
							.zhutu {
								width: 100%;
							}
							.zhezhao {
								position: absolute;
								left: 4px;
								top: 0;
								right: 4px;
								bottom: 4px;
								z-index: 21;
								background-color: rgba(0, 0, 0, 0.5);
							}
							.zz_tit {
								position: absolute;
								left: 30px;
								bottom: 65px;
								font-size: 36px;
								font-weight: bold;
								z-index: 22;
								color: #fff;
								animation-duration: 0.4s;
							}
							.zz_con {
								position: absolute;
								z-index: 22;
								color: #fff;
								bottom: 50px;
								left: 0;
								right: 0;
								padding: 0 30px;
								font-size: 18px;
								animation-duration: 0.4s;
								text-align: left;
								opacity: 0;
							}
						}
						.item_sty1 {
							width: 28%;
						}
						.item_sty2 {
							width: 43%;
						}
					}
					.rd_box {
						position: absolute;
						bottom: 10px;
						width: 100%;
						left: 0;
						z-index: 9;
					}
				}
			}
		}
		@media screen and (max-width: 1780px) {
			.pc_box {
				.swiper_wrap {
					.slid3_box {
						.sort_box {
							max-width: 1300px;
							.sort_item {
								.zz_tit {
									font-size: 32px;
									font-weight: 400;
								}
								.zz_con {
									font-size: 16px;
								}
							}
						}
					}
				}
			}
		}
		@media screen and (max-width: 1480px) {
			.pc_box {
				.swiper_wrap {
					.slid3_box {
						.sort_box {
							max-width: 940px;
							.sort_item {
								.zz_tit {
									font-size: 32px;
									font-weight: 400;
								}
								.zz_con {
									font-size: 16px;
								}
							}
						}
					}
				}
			}
		}
		.phone_home {
			padding: 48px 0 95px 0;
			background-image: url("../../images/bgimg3.png");
			.swiper3 {
				.swiper_box3 {
					.swiper_item3 {
						.img_box3 {
							img {
								width: 100%;
								display: block;
							}
						}
					}
				}
			}
			.wl_img {
				img {
					width: 100%;
				}
			}
			.key_list {
				padding: 0.56rem 0.53rem;
				.key_item {
					margin-bottom: 0.53rem;
					.key_tit {
						color: #c0494b;
						font-size: 23px;
						margin-bottom: 0.16rem;
						text-align: center;
					}
					.key_p1 {
						text-align: center;
						font-size: 17px;
						color: #333;
						margin-bottom: 0.27rem;
					}
					.key_d1 {
						img {
							width: 100%;
						}
					}
				}
			}
		}
	}
	.kp_box {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		z-index: 5000000;
		display: flex;
		img {
			width: 50%;
			display: inline-block;
		}
		.kp_left {
			animation-delay: 0.5s;
			animation-duration: 2.5s;
		}
		.kp_right {
			animation-delay: 0.5s;
			animation-duration: 2.5s;
		}
	}
}
</style>